import React from "react";
import { Avatar } from "primereact/avatar";
import TruncatedText from "app/uicomponents/microcomponents/TruncatedText";

interface AvatarWithNameProps {
  imageUrl?: string;
  name: string;
  avatarSize?: number;
  shape?: "circle" | "square";
  /**
   * Override for avatar label when no image (e.g. first name initial).
   * Falls back to first char of name.
   */
  initial?: string;
  /** Inline styles for the avatar (e.g. border color). */
  avatarStyle?: React.CSSProperties;
  nameClassName?: string;
  /**
   * Optional full value used for tooltip rendering when `name` is truncated for display.
   */
  tooltipText?: string;
  className?: string;
}

const AvatarWithName: React.FC<AvatarWithNameProps> = ({
  imageUrl,
  name,
  avatarSize = 36,
  shape = "circle",
  initial,
  avatarStyle,
  nameClassName = "",
  tooltipText,
  className = "",
}) => {
  const displayName = name != null && typeof name === "string" ? name : String(name ?? "");
  const label = initial ?? displayName?.charAt(0)?.toUpperCase();
  return (
    <div className={`flex items-center gap-2 ${className} min-w-0`}>
      <Avatar
        image={imageUrl}
        shape={shape}
        label={label}
        style={{ width: avatarSize, height: avatarSize, ...avatarStyle }}
      />

      <div className="min-w-0 flex-1">
        <TruncatedText
          text={displayName || "-"}
          tooltipText={tooltipText ?? (displayName || "-")}
          className={`${nameClassName} block`}
          maxWidth="max-w-full"
          tooltipId={`avatar-with-name-${displayName}-${React?.useId()}`}
        />
      </div>
    </div>
  );
};

export default AvatarWithName;
